export default class SideLinks {
  constructor(el) {
    this.el = el
    this.triggers = el.querySelectorAll('[data-panel-target]')
    // les panneaux et l'overlay sont frères de .side-links (pas enfants), pour ne pas hériter
    // de son transform qui créerait un containing block cassant leur position: fixed
    this.panels = el.parentElement.querySelectorAll('.side-links--panel')
    this.overlay = el.parentElement.querySelector('.side-links--overlay')
    this.init()
  }

  init() {
    if (!this.panels.length) return

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        this.open(trigger)
      })
    })

    this.panels.forEach((panel) => {
      panel.querySelector('.side-links--close')?.addEventListener('click', () => this.close())
    })

    this.overlay?.addEventListener('click', () => this.close())
  }

  open(trigger) {
    const target = trigger.dataset.panelTarget

    this.panels.forEach((panel) => panel.classList.toggle('is-open', panel.dataset.panel === target))
    this.triggers.forEach((t) => t.classList.toggle('is-active', t === trigger))
    this.overlay?.classList.add('is-open')
    this.el.classList.add('is-panel-open')
  }

  close() {
    this.panels.forEach((panel) => panel.classList.remove('is-open'))
    this.triggers.forEach((t) => t.classList.remove('is-active'))
    this.overlay?.classList.remove('is-open')
    this.el.classList.remove('is-panel-open')
  }
}
